/**
 * Created by chenzheyu on 2017/6/12.
 */
import XKcouponMod from './src/couponMod'

XKcouponMod.install = function (Vue) {
  Vue.component(XKcouponMod.name, XKcouponMod)
}

export default XKcouponMod



// WEBPACK FOOTER //
// ./src/components/module/couponMod/index.js